import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { ConsumerService } from "../../../services/api/consumer.service";
import { ConsumerActions } from "../../actions/consumer.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class AchAddEffects {
	add = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerActions.ach.add),
			switchMap((action) =>
				this.consumerService.achAccountCreate(action.request).pipe(
					map(() => ConsumerActions.ach.addSuccess()),
					catchError((error) => of(ConsumerActions.ach.addFail(new FailState(error))))
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private consumerService: ConsumerService
	) {}
}
